/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MapSearchResponseDto,
  SearchEntityFilter,
  SearchPagedRequestDto,
  SearchPagedResponseDto,
  SearchResultDto,
} from '../models/index';
import {
    MapSearchResponseDtoFromJSON,
    MapSearchResponseDtoToJSON,
    SearchEntityFilterFromJSON,
    SearchEntityFilterToJSON,
    SearchPagedRequestDtoFromJSON,
    SearchPagedRequestDtoToJSON,
    SearchPagedResponseDtoFromJSON,
    SearchPagedResponseDtoToJSON,
    SearchResultDtoFromJSON,
    SearchResultDtoToJSON,
} from '../models/index';

export interface SearchMapGETRequest {
    query: string;
    cityFilter?: string;
    radiusFilter?: string;
    hasFilter?: string;
    currentLatitude?: number;
    currentLongitude?: number;
}

export interface SearchPagedPOSTRequest {
    searchPagedRequestDto?: SearchPagedRequestDto;
}

export interface SearchSpendAnalysisGETRequest {
    query?: string;
    isFilter?: SearchEntityFilter;
    dateFilter?: string;
    statusFilter?: string;
    amountFilter?: string;
    categories?: Array<string>;
}

/**
 * SearchApi - interface
 * 
 * @export
 * @interface SearchApiInterface
 */
export interface SearchApiInterface {
    /**
     * Creates request options for searchMapGET without sending the request
     * @param {string} query 
     * @param {string} [cityFilter] 
     * @param {string} [radiusFilter] 
     * @param {string} [hasFilter] 
     * @param {number} [currentLatitude] 
     * @param {number} [currentLongitude] 
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    searchMapGETRequestOpts(requestParameters: SearchMapGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} query 
     * @param {string} [cityFilter] 
     * @param {string} [radiusFilter] 
     * @param {string} [hasFilter] 
     * @param {number} [currentLatitude] 
     * @param {number} [currentLongitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    searchMapGETRaw(requestParameters: SearchMapGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MapSearchResponseDto>>;

    /**
     */
    searchMapGET(requestParameters: SearchMapGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MapSearchResponseDto>;

    /**
     * Creates request options for searchPagedPOST without sending the request
     * @param {SearchPagedRequestDto} [searchPagedRequestDto] 
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    searchPagedPOSTRequestOpts(requestParameters: SearchPagedPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {SearchPagedRequestDto} [searchPagedRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    searchPagedPOSTRaw(requestParameters: SearchPagedPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPagedResponseDto>>;

    /**
     */
    searchPagedPOST(requestParameters: SearchPagedPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPagedResponseDto>;

    /**
     * Creates request options for searchSpendAnalysisGET without sending the request
     * @param {string} [query] 
     * @param {SearchEntityFilter} [isFilter] 
     * @param {string} [dateFilter] 
     * @param {string} [statusFilter] 
     * @param {string} [amountFilter] 
     * @param {Array<string>} [categories] 
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    searchSpendAnalysisGETRequestOpts(requestParameters: SearchSpendAnalysisGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [query] 
     * @param {SearchEntityFilter} [isFilter] 
     * @param {string} [dateFilter] 
     * @param {string} [statusFilter] 
     * @param {string} [amountFilter] 
     * @param {Array<string>} [categories] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    searchSpendAnalysisGETRaw(requestParameters: SearchSpendAnalysisGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultDto>>;

    /**
     */
    searchSpendAnalysisGET(requestParameters: SearchSpendAnalysisGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultDto>;

}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI implements SearchApiInterface {

    /**
     * Creates request options for searchMapGET without sending the request
     */
    async searchMapGETRequestOpts(requestParameters: SearchMapGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling searchMapGET().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['Query'] = requestParameters['query'];
        }

        if (requestParameters['cityFilter'] != null) {
            queryParameters['CityFilter'] = requestParameters['cityFilter'];
        }

        if (requestParameters['radiusFilter'] != null) {
            queryParameters['RadiusFilter'] = requestParameters['radiusFilter'];
        }

        if (requestParameters['hasFilter'] != null) {
            queryParameters['HasFilter'] = requestParameters['hasFilter'];
        }

        if (requestParameters['currentLatitude'] != null) {
            queryParameters['CurrentLatitude'] = requestParameters['currentLatitude'];
        }

        if (requestParameters['currentLongitude'] != null) {
            queryParameters['CurrentLongitude'] = requestParameters['currentLongitude'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Search/map`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchMapGETRaw(requestParameters: SearchMapGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MapSearchResponseDto>> {
        const requestOptions = await this.searchMapGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MapSearchResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchMapGET(requestParameters: SearchMapGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MapSearchResponseDto> {
        const response = await this.searchMapGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPagedPOST without sending the request
     */
    async searchPagedPOSTRequestOpts(requestParameters: SearchPagedPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Search/paged`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPagedRequestDtoToJSON(requestParameters['searchPagedRequestDto']),
        };
    }

    /**
     */
    async searchPagedPOSTRaw(requestParameters: SearchPagedPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPagedResponseDto>> {
        const requestOptions = await this.searchPagedPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchPagedPOST(requestParameters: SearchPagedPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPagedResponseDto> {
        const response = await this.searchPagedPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchSpendAnalysisGET without sending the request
     */
    async searchSpendAnalysisGETRequestOpts(requestParameters: SearchSpendAnalysisGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['isFilter'] != null) {
            queryParameters['isFilter'] = requestParameters['isFilter'];
        }

        if (requestParameters['dateFilter'] != null) {
            queryParameters['dateFilter'] = requestParameters['dateFilter'];
        }

        if (requestParameters['statusFilter'] != null) {
            queryParameters['statusFilter'] = requestParameters['statusFilter'];
        }

        if (requestParameters['amountFilter'] != null) {
            queryParameters['amountFilter'] = requestParameters['amountFilter'];
        }

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Search/spend-analysis`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchSpendAnalysisGETRaw(requestParameters: SearchSpendAnalysisGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultDto>> {
        const requestOptions = await this.searchSpendAnalysisGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchSpendAnalysisGET(requestParameters: SearchSpendAnalysisGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultDto> {
        const response = await this.searchSpendAnalysisGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
